<template lang="pug">
.content-wrap
  .content-top
    .con.review-page
      .page-wrapper
        // BANNER
        section.banner-r
          img(src='/new/img/review page/webp file/banner/BANNER.jpg' alt='Main Banner')
        // WHY CHOOSE US
        section.why-choose-us
          .w-100.text-center
            img.sec-heading(src='/new/img/review page/webp file/1. why choose us part/why choose us.webp' alt='Why Choose Us')
          .icons-row
            img(src='/new/img/review page/webp file/1. why choose us part/A.webp' alt='100% Guarantee')
            img(src='/new/img/review page/webp file/1. why choose us part/B.webp' alt='6 Tahun Dipercayai')
            img(src='/new/img/review page/webp file/1. why choose us part/C.webp' alt='Customer Services')
            img(src='/new/img/review page/webp file/1. why choose us part/D.webp' alt='Establish Year')
        // LEAVE REVIEWS & CLAIM FREE
        section.reviews-claim
          img.sec-heading(src='/new/img/review page/webp file/2. leave review & claim free/leave review.webp' alt='Leave Reviews & Claim Free')
          //- #starRating.star-rating
            img#starRowImg.star-row-img(src='/new/img/review page/webp file/2. leave review & claim free/star empty.webp' alt='Rating')
            .star-zones
              span.star-zone(data-val='1')
              span.star-zone(data-val='2')
              span.star-zone(data-val='3')
              span.star-zone(data-val='4')
              span.star-zone(data-val='5')
          #starRating.star-rating
            img#starRowImg.star-row-img(
              :src="currentStarSrc"
              alt="Rating"
            )

            .star-zones
              span.star-zone(
                v-for="val in 5"
                :key="val"
                :data-val="val"
                @click="selectRating(val)"
                @mouseover="hoverRating(val)"
                @mouseout="resetHover"
              )
          .review-input-wrap
            img.review-bar-img(:src='txtAreaSrc' alt='')
            textarea#reviewText.review-textarea(rows="5" minlength="5" maxlength="100" v-model.trim="$v.userComment.$model")
          .input-feedback.text-danger(v-if="$v.userComment.$dirty == true && currentRating == 0") {{ $t("message.list.ratingRequired") }}
          ValidateResult.text-danger(v-else :value="$v.userComment" :name="$tc('ui.review', 2)")
          button#postBtn.img-btn(@click.stop="submitReview")
            img(src='/new/img/review page/webp file/2. leave review & claim free/post button.webp' alt='Post')
        // WHAT OUR CUSTOMER SAY
        section.our-customers-say
          img.sec-heading(src='/new/img/review page/webp file/3. what our customer say/what our customer say.webp' alt='What Our Customer Say?')
          #reviewsList.reviews-list
            template(v-if="commentList.length > 0")
              .review-card(v-for="comment in commentList")
                img.review-card-bg(src="/new/img/review page/webp file/3. what our customer say/user review  bar.webp")
                .review-card-body
                  .review-card-header
                    img.review-avatar(src="/new/img/review page/webp file/3. what our customer say/user profile .webp")
                    .review-meta
                      p.review-username {{comment.account_id}}
                      p.review-date {{$moment(comment.created_date).format('D MMMM YYYY')}}
                      img.review-stars-img(:src="`/new/img/review page/webp file/3. what our customer say/${comment.rating}.webp`")
                  p.review-text {{comment.comment}}
            template(v-else)
              .review-card
                img.review-card-bg(src="/new/img/review page/webp file/3. what our customer say/user review  bar.webp")
                .review-card-body.d-flex.justify-content-center.align-items-center
                  .no-data
                    span
                      i.fa-regular.fa-newspaper
                    span.ms-3 No data
          #reviewPagination.pagination
            paginate(
              v-if="commentList.length > 0"
              :click-handler="changePage"
              :pageCount="pageCount"
              :page-range="4"
              :margin-pages="3"
              :container-class="'p-0 m-0'"
              :page-class="'page-num'"
              :page-link-class="'page-num'"
              :prev-class="'hidden'"
              :next-class="'hidden'"
            )
        // TOP 10 WITHDRAWAL
        section.top-10-withdrawal
          .top10-tabs
            img#tab-withdraw.tab-img(:class="{'active': currentTab == 0}" data-tab='withdraw' :src='withdrawTabImg' alt='Top Withdraw' @click="switchTab(0)")
            img#tab-deposit.tab-img(:class="{'active': currentTab == 1}" data-tab='deposit' :src='depoTabImg' alt='Top Deposit' @click="switchTab(1)")
          img.top10-title-img(v-if="currentTab == 0" src='/new/img/review page/webp file/4. Top 10 Withdraw/top 10 withdraw.webp' alt='Top 10 Withdrawal')
          img.top10-title-img(v-if="currentTab == 1" src='/new/img/review page/webp file/4. Top 10 Withdraw/top 10 deposit.webp' alt='Top 10 deposit')
          #top10List.top10-list
            template(v-if="displayData.length > 0")
              .top10-row(v-for="(data, index) in displayData")
                img.top10-row-bg(src="/new/img/review page/webp file/4. Top 10 Withdraw/top 10 bar.webp")
                .top10-row-content
                  .rank-badge-wrap(v-if="index < 3")
                    img.rank-badge-img(:src="`/new/img/review page/webp file/4. Top 10 Withdraw/${index+1}.webp`")
                    span.rank-badge-num {{index + 1}}
                  span.rank-num-plain(v-if="index >= 3") {{index + 1}}
                  span.row-id(v-if="data.nickname") {{data.nickname}}
                  span.row-id(v-else="data.nickname") {{data.member_id}}
                  span.row-amount(v-if="currentTab == 0") RM{{ $numeral(data.withdrawal_amount).format("0,0.00") }}
                  span.row-amount(v-if="currentTab == 1") RM{{ $numeral(data.deposit_amount).format("0,0.00") }}
            template(v-else)
              .top10-row
                img.top10-row-bg(src="/new/img/review page/webp file/4. Top 10 Withdraw/top 10 bar.webp")
                .top10-row-content.justify-content-center
                  span
                    i.fa-regular.fa-newspaper
                  span.ms-3 No data
        // WINNING TIPS + RM100 CHALLENGE
        section.small-happiness-challenge
          //- .two-frames
            .tip-frame
              img(src='/new/img/review page/webp file/cucci_rm.png' alt='cucci rm')
            .tip-frame
              img(src='/new/img/review page/webp file/cucci_rm.png' alt='cucci rm')
          h2.challenge-title
            | RM100 SMALL HAPPINESS
            br
            | CHALLENGE
          .carousel-wrap
            .grid#grid
              p.loading-txt(v-if="loading") Loading videos...

              p.loading-txt(v-else-if="videoError")
                | Could not load videos. Please check your connection.

              template(v-else)
                a.card(
                  v-for="(item, index) in displayVideos"
                  :key="index"
                  :href="item.link"
                  target="_blank"
                  rel="noopener"
                )
                  img.thumb(
                    :src="getThumbnail(item)"
                    :alt="item.title"
                    loading="lazy"
                  )

                  .play-btn

                  .title-overlay {{ item.title }}
          button.img-btn(@click="openYoutubePlaylist")
            img.view-more-btn(src='/new/img/review page/webp file/view more button.webp' alt='View More')
          //- h2.challenge-title
            | RM100 SMALL HAPPINESS
            br
            | CHALLENGE
          //- .two-frames.challenge-frames
            .tip-frame
              img(src='/new/img/review page/webp file/tiktok_video.png' alt='Challenge Video 1')
            .tip-frame
              img(src='/new/img/review page/webp file/tiktok_video.png' alt='Challenge Winning Tip')
          //- button.img-btn
            img.challenge-now-btn(src='/new/img/review page/webp file/challenge now.webp' alt='Challenge Now')
        // HOW TO WIN & PLAY
        section.how-to-win-play
          img(src='/new/img/review page/webp file/5. how to win & play/how to play & win.webp' alt='How to Win & Play?')
        // 128% WELCOME BONUS BANNER
        section.bonus-banner
          img(src='/new/img/review page/webp file/6. 128_ banner/128_ banner.webp' alt='128% Welcome Bonus + 288X Free Spins')
        // SERVICES ADVANTAGES
        section.service-advantages
          .svc-top-row
            .svc-times-col
              img.sec-heading(src='/new/img/review page/webp file/7. services advantages/services advantage.webp' alt='Services Advantages')
              .svc-times-values
                p.svc-value
                  | 100
                  span.svc-unit mins
                p.svc-value
                  | 5
                  span.svc-unit mins
            .svc-rating-col
              img.rating-stars-img(src='/new/img/review page/webp file/7. services advantages/review part 5star.webp')
              p.rating-big 5.0
              p.rating-reviews 1000 REVIEWS
          .svc-stats-row
            .stat-block
              img(src='/new/img/review page/webp file/7. services advantages/withdraw amount.webp' alt='')
              p.stat-value RM1.1M
            .stat-block
              img(src='/new/img/review page/webp file/7. services advantages/active player.webp' alt='')
              p.stat-value 8888K
            .stat-block
              img(src='/new/img/review page/webp file/7. services advantages/establish year.webp' alt='')
      footerInfo
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import ValidateResult from "@/library/ValidateResult"
import Paginate from "vuejs-paginate";
import footerInfo from '@/views/default/_footerArticle.vue'
export default{
  components: {
    ValidateResult,
    Paginate,
    footerInfo
  },
  data(){
    return{
      BASE: '/new/img/review page/webp file',
      currentRating: 0,
      hoverValue: null, 
      userComment: "",
      commentList: [],
      currentPage: 1,
      // pageSize: 10,
      playlistId: 'PLAmHpU2QgEDOlblQDUvFllaigVWw3FfI8',
      youtubeApiKey: 'AIzaSyCWCeWzRwAy8vaHcifVONbBC9Ub3VezQRM',
      maxVideos: 6,

      videos: [],
      loading: true,
      videoError: false,
      topWithdrawal: [],
      topDeposit: [],
      feedback:{
        success: true,
        status:""
      },
      currentTab: 0
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    leaveStarSrcs() {
      return [
        `${this.BASE}/2. leave review & claim free/star empty.webp`,
        `${this.BASE}/2. leave review & claim free/star 1.webp`,
        `${this.BASE}/2. leave review & claim free/star 2.webp`,
        `${this.BASE}/2. leave review & claim free/star 3.webp`,
        `${this.BASE}/2. leave review & claim free/star 4.webp`,
        `${this.BASE}/2. leave review & claim free/star full.webp`
      ]
    },

    currentStarSrc() {
      const rating = this.hoverValue !== null
        ? this.hoverValue
        : this.currentRating

      return this.leaveStarSrcs[rating]
    },
    txtAreaSrc(){
      if(this.userComment == ""){
        return "/new/img/review page/webp file/2. leave review & claim free/review bar.webp"
      }else{
        return "/new/img/review page/webp file/2. leave review & claim free/review bar B.webp"
      }
    },
    noHistory(){
      if(this.commentList.length > 0){
        return false
      }else{
        return true
      }
    },
    pageCount() {
      if (!this.noHistory) {
        var page = this.commentList[0].totalrows / 100;
        if (page % 1 != 0) {
          page = page + 1;
        }
        return Math.floor(page);
      } else {
        return 0;
      }
    },
    youtubeApiUrl() {
      return `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${this.maxVideos}&playlistId=${this.playlistId}&key=${this.youtubeApiKey}`
    },

    playlistUrl() {
      return `https://www.youtube.com/playlist?list=${this.playlistId}`
    },

    displayVideos() {
      return [...this.videos, ...this.videos]
    },
    withdrawTabImg(){
      if(this.currentTab == 0){
        return '/new/img/review page/webp file/4. Top 10 Withdraw/top withdraw.webp'
      }else{
        return '/new/img/review page/webp file/4. Top 10 Withdraw/top withdraw B.webp'
      }
    },
    depoTabImg(){
      if(this.currentTab == 0){
        return '/new/img/review page/webp file/4. Top 10 Withdraw/top deposit.webp'
      }else{
        return '/new/img/review page/webp file/4. Top 10 Withdraw/top deposit B.webp'
      }
    },
    displayData(){
      if(this.currentTab == 0){
        return this.topWithdrawal
      }else{
        return this.topDeposit
      }
    }
  },
  validations:{
    userComment:{
      required,
      minLength: minLength(5),
      maxLength: maxLength(100)
    },
  },
  created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/review`);
		// this.getSeo("contactUs")
	},
  mounted(){
    window.scroll(0,0)
    this.reviewList()
    this.loadVideos()
    this.getGraphData()
  },
  methods:{
    switchTab(option){
      this.currentTab = option
    },
    getGraphData(){
      let url = config.getGraphData();
      // var json = {
      //   app_id : config.app_id
      // }
      this.$http.get(url).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;
              if (this.feedback.success == true) {
                this.topWithdrawal = response.data.value.withrawal;
                this.topDeposit = response.data.value.deposit;
                
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$t("ui.attention"), vm.$t("message.list." + response.status), "info", this);
          }
        }
      );
    },
    reviewList(){
      let page_number = this.currentPage
      this.$store
        .dispatch("user/reviewList", {page_number})
        .then(response => {
          if (response.success == true) {
            this.commentList = response.data
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          }
        })
        .catch(response => {
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
          }
        });
    },
    changePage(e) {
      this.currentPage = e;
      this.reviewList()
    },
    selectRating(val) {
      this.currentRating = val
    },

    hoverRating(val) {
      this.hoverValue = val
    },

    resetHover() {
      this.hoverValue = null
    },
    submitReview(){
      if (this.sessionToken) {
        this.$v.$touch();
        // if(this.jsonRating.length !== this.surveyQuestions.length){
        //   this.starComplete = false;
        //   this.showError = true;
        //   return;
        // }else{
        //   this.starComplete = true;
        //   this.showError = false;
        // }
        if(!this.$v.$invalid && this.currentRating > 0){
          
          let account_id = this.accountID
          let auth_token = this.sessionToken
          let rating = this.currentRating
          let comment = this.userComment
          this.$store
            .dispatch("user/memberReview2", { account_id, auth_token, rating, comment })
            .then(response => {
              if (response.success == true) {
                this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
                this.reset()
              } else {
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            });
        }
      }else{
        this.$router.push("/login").catch(err => {});
      }
      
      
    },
    reset(){
      this.currentRating = 0
      this.$v.$reset()

    },
    async loadVideos() {
      this.loading = true
      this.videoError = false

      try {
        const res = await fetch(this.youtubeApiUrl)
        const data = await res.json()

        if (!res.ok) {
          throw new Error(data.error?.message || `YouTube API error: ${res.status}`)
        }

        if (!data.items || data.items.length === 0) {
          throw new Error('No items')
        }

        this.videos = data.items
          .map(item => {
            const snippet = item.snippet || {}
            const videoId = snippet.resourceId?.videoId || ''

            return {
              videoId,
              title: snippet.title || '',
              link: `https://www.youtube.com/watch?v=${videoId}`,
              thumbnail:
                snippet.thumbnails?.maxres?.url ||
                snippet.thumbnails?.standard?.url ||
                snippet.thumbnails?.high?.url ||
                snippet.thumbnails?.medium?.url ||
                snippet.thumbnails?.default?.url ||
                `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
            }
          })
          .filter(item => item.videoId)
      } catch (error) {
        console.error(error)
        this.videoError = true
        this.videos = []
      } finally {
        this.loading = false
      }
    },

    getThumbnail(item) {
      if (!item) {
        return ''
      }

      return item.thumbnail || `https://i.ytimg.com/vi/${item.videoId}/hqdefault.jpg`
    },

    openYoutubePlaylist() {
      window.open(this.playlistUrl, '_blank', 'noopener')
    },
  }
}
</script>
<style lang="scss" scoped>

.page-wrapper {
  background: #0d0020;
  width: 100%;
  overflow: hidden;
}
.img-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: block;
}

/* ── BANNER ─────────────────────────────────── */
.banner-r img {
  width: 100%;
}

/* ── WHY CHOOSE US ───────────────────────────── */
.why-choose-us {
  padding: 16px 0;
}

.why-choose-us .sec-heading {
  width: 50%;
  margin: 1rem auto;
}

.icons-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 4px 12px 8px;
  gap: 6px;
}

.icons-row img {
  flex: 1;
  max-width: 23%;
  height: auto;
}

/* ── LEAVE REVIEWS & CLAIM FREE ─────────────── */
.reviews-claim {
  background: #0d0020;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 28px;
}

.reviews-claim .sec-heading {
  width: 80%;
  margin: 1rem auto;
}

.star-rating {
  position: relative;
  width: 50%;
  margin-bottom: 10px;
}

.star-row-img {
  width: 100%;
  margin: auto;
  display: block;
  cursor: pointer;
}

.star-zones {
  position: absolute;
  top: 14px;
  left: 0;
  right: 0;
  bottom: 10px;
  display: flex;
}

.star-zone {
  flex: 1;
  cursor: pointer;
}

.review-input-wrap {
  position: relative;
  width: 92%;
  margin: 6px 0 14px;
}

.review-bar-img {
  width: 100%;
  display: block;
}

.review-textarea {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 500;
  padding: 14px 16px;
  resize: none;
}

.review-textarea::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.reviews-claim .img-btn {
  width: 30%;
  margin-top: 16px;
}

/* ── WHAT OUR CUSTOMER SAY ───────────────────── */
.our-customers-say {
  background: #0d0020;
  padding-bottom: 8px;
}

.our-customers-say .sec-heading {
  width: 80%;
  margin: 1rem auto;
}

.reviews-list {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.review-card {
  position: relative;
  width: 100%;
  p {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
}

.review-card-bg {
  width: 100%;
  height: 100px;
  display: block;
}

.review-card-body {
  position: absolute;
  inset: 0;
  padding: 12px 12px;
  overflow: hidden;
  @media (min-width: 768px) {
    padding: 15px 18px;
  }
}

.review-card-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.review-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
}

.review-meta {
  flex: 1;
  min-width: 0;
}

.review-username {
  font-family: "Bebas Neue", sans-serif;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.5px;
}

.review-date {
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  color: #fff;
  font-size: 10px;
  margin-bottom: 3px;
}

.review-stars-img {
  width: 80px;
  display: block;
  margin-left: -6px;
}

.review-text {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #fff;
  font-size: 12px;
  line-height: 1.45;
  margin-top: 7px;
  @media (max-width: 767px) {
    font-size: 8px;
  }
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  padding: 14px 0 20px;
}

.pagination ul li {
  list-style: none;
  display: inline-block;
}

.page-num {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #9a1bc9;
  font-size: 18px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.15s;
}

.page-num.selected {
  font-weight: 700;
  background: #0d0020;
  color: #fff;
  box-shadow: 0 0 10px rgba(212, 78, 255, 0.9);
}

/* ── TOP 10 WITHDRAWAL ───────────────────────── */
.top-10-withdrawal {
  background-image: url("/new/img/review page/webp file/4. Top 10 Withdraw/top 10 background.webp");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 22px 0;
  display: flex;
  margin: 16px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  p {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

}

.top10-tabs {
  display: flex;
  justify-content: center;
  width: 100%;
}

.tab-img {
  width: 30%;
  cursor: pointer;
  transition: opacity 0.15s;
}

.top10-title-img {
  width: 80%;
  margin: auto;
}

.top10-list {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.top10-row {
  position: relative;
  width: 100%;
  margin-bottom: -30px;
}

.top10-row:last-child {
  margin-bottom: 0;
}

.top10-row-bg {
  width: 100%;
  display: block;
}

.top10-row-content {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  // padding: 0 40px;
  padding: 0 55px;
  @media(max-width: 767px){
    padding: 0 24px;
  }
}

.rank-badge-wrap {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.rank-badge-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rank-badge-num {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #ffd700;
  font-size: 13px;
}

.rank-num-plain {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 13px;
  flex-shrink: 0;
}

.row-id {
  flex: 1;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 13px;
}

.row-amount {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 13px;
}

/* ── SMALL HAPPINESS CHALLENGE ───────────────── */
.small-happiness-challenge {
  background: #0d0020;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 14px;
  gap: 2rem;
}

.two-frames {
  display: flex;
  gap: 10px;
  width: 100%;
}

.tip-frame {
  flex: 1;
  overflow: hidden;
}

.tip-frame img {
  width: 100%;
  display: block;
}

.challenge-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  color: #fff;
  font-size: 22px;
  text-align: center;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.small-happiness-challenge .challenge-now-btn,
.small-happiness-challenge .view-more-btn {
  width: 50%;
  margin: auto;
}

/* ── HOW TO WIN & PLAY ───────────────────────── */
.how-to-win-play {
  padding: 0 16px;
}

.how-to-win-play img {
  width: 100%;
}

/* ── 128% BONUS BANNER ───────────────────────── */
.bonus-banner img {
  width: 95%;
  margin: auto;
}

/* ── SERVICES ADVANTAGES ─────────────────────── */
.service-advantages {
  background: #0d0020;
  padding-bottom: 24px;
  margin: 16px;
}

.svc-top-row {
  display: flex;
  overflow: hidden;
  // height: 120px;
  @media(max-width: 767px){
    height: 120px;
  }
  p {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
}

.svc-times-col {
  flex: 3;
  position: relative;
}

.svc-times-values {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(-25%, -50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
}

.svc-value {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #fdfa0e;
  font-size: 30px;
  line-height: 1;
  @media(max-width: 767px){
    font-size: 15px;
  }
}

.svc-value span {
  font-size: 8px;
}

.svc-rating-col {
  flex: 1;
  position: relative;
}

.svc-rating-col .rating-big {
  position: absolute;
  top: 28%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #fff;
  font-size: 46px;
  line-height: 1;
}

.svc-rating-col .rating-reviews {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #fff;
  font-size: 8px;
}

.svc-times-col img,
.svc-rating-col img {
  width: 100%;
  height: 100%;
}

.rating-stars-img {
  width: 90%;
}

.svc-stats-row {
  display: flex;
  @media(min-width: 768px){
    height: 220px;
  }
}

.stat-block {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  // height: 130px;
  // height: 160px;
  height: 100%;
  @media (max-width: 767px) {
    height: 130px;
  }
}

.stat-block img {
  width: 100%;
  height: 100%;
  // @media(min-width: 768px){
  //   height: 225px;
  // }
}

.stat-value {
  position: absolute;
  top: 50%;
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  color: #fdfa0e;
  font-size: 20px;
  line-height: 1;
  @media(min-width: 768px){
    // top: 70%;
  }
}


.carousel-wrap {
  width: 100%;
  overflow: hidden;
  margin-bottom: 24px;
}

.grid {
  display: flex;
  gap: 10px;
  padding: 0 12px;
  width: max-content;
  animation: scrollLeft 20s linear infinite;
}

.grid:hover { animation-play-state: paused; }

@keyframes scrollLeft {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.card {
  position: relative;
  width: 130px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  text-decoration: none;
  border: 2px solid rgba(150,80,255,0.25);
}

.card .thumb {
  width: 100%;
  aspect-ratio: 9 / 16;
  object-fit: cover;
  display: block;
}

.card .play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  background: rgba(0,0,0,0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.card .play-btn::after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 9px 0 9px 16px;
  border-color: transparent transparent transparent #fff;
  margin-left: 3px;
}

.card:hover .play-btn { background: rgba(255,0,0,0.85); }

.card .title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.85));
  color: #fff;
  font-size: 9px;
  padding: 20px 6px 7px;
  line-height: 1.3;
}

</style>